export enum ViewType {
	TABLE = 'TABLE',
	RULE = 'RULE',
}

export enum RuleType {
	INBOUND = 'inbound',
	UPDATE = 'update',
	OUTBOUND = 'outbound',
}

export enum StateUpdateType {
	ADD = 'ADD',
	SET = 'SET',
	REMOVE = 'REMOVE',
}

export enum ConditionType {
	DEFAULT,
	CONTAINS = 'CONTAINS',
	NOT_CONTAINS = 'NOT_CONTAINS',
	EQUALS = 'EQUALS',
	NOT_EQUALS = 'NOT_EQUALS',
	IS_EMPTY = 'IS_EMPTY',
	IS_NOT_EMPTY = 'IS_NOT_EMPTY',
	MORE_THAN = 'MORE_THAN',
	MORE_THAN_OR_EQUAL = 'MORE_THAN_OR_EQUAL',
	LESS_THAN = 'LESS_THAN',
	LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
	STARTS_WITH = 'STARTS_WITH',
	ENDS_WITH = 'ENDS_WITH',
}

export enum ActionType {
	DEFAULT,
	START_WORKFLOW = 'START_WORKFLOW',
	SEND_NOTIFICATION = 'SEND_NOTIFICATION',
	CHANGE_PROPERTY_VALUE = 'CHANGE_PROPERTY_VALUE',
	EXECUTE_SCRIPT = 'EXECUTE_SCRIPT',
}

export enum ConditionRowValueType {
	PROPERTY = 'PROPERTY',
	CONDITION = 'CONDITION',
	VALUE = 'VALUE',
	DATE_TYPE = 'DATE_TYPE',
	DATE_UNIT = 'DATE_UNIT',
}

export enum WorkflowType {
	DEFAULT,
	PARALLEL = 'PARALLEL',
	POOLED = 'POOLED',
}

export enum RelativeDateUnitType {
	DEFAULT,
	MINUTES = 'MINUTES',
	HOURS = 'HOURS',
	DAYS = 'DAYS',
	WEEKS = 'WEEKS',
	MONTHS = 'MONTHS',
	YEARS = 'YEARS',
}

export enum DateConditionType {
	RELATIVE = 'RELATIVE',
	ABSOLUTE = 'ABSOLUTE',
}

export enum ValidationType {
	BASIC_SETTINGS = 'BASIC_SETTINGS',
	CONDITIONS = 'CONDITIONS',
	ACTIONS = 'ACTIONS',
	ACTION = 'ACTION',
}

export enum StringValidation {
	BASIC_SETTINGS = 'basicSettings',
	INITIAL_CONDITIONS = 'initialConditions',
}

export enum ExitType {
	EXIT_RPA = 'EXIT_RPA',
	HOMEPAGE = 'HOMEPAGE',
	NEW_RULE = 'NEW_RULE',
	EXISTING_RULE = 'EXISTING_RULE',
}

export enum LoadingType {
	NONE,
	RULE_ACTIVE_SWITCH,
}
